import {
  MarksActionTypes,
  UniqueData,
  CREATE_FINAL_MARK_STARTED,
  UPDATE_FINAL_MARK_STARTED,
  CREATE_PARTIAL_MARK_STARTED,
  UPDATE_PARTIAL_MARK_STARTED,
  DELETE_PARTIAL_MARK_STARTED,
  CREATE_FINAL_MARKS_STARTED,
  UPDATE_FINAL_MARKS_STARTED,
  CREATE_PARTIAL_MARKS_STARTED,
  UPDATE_PARTIAL_MARKS_STARTED,
  DELETE_PARTIAL_MARKS_STARTED,
  DELETE_FINAL_MARK_STARTED,
  OPEN_SIGN_MARK_MODAL,
  CLOSE_SIGN_MARK_MODAL,
  SIGN_MARKS_START,
  OPEN_CONFIRM_CODE_MARK_MODAL,
  CLOSE_CONFIRM_CODE_MARK_MODAL,
  CONFIRM_CODE_START,
  OPEN_EMPLOYEE_CONFIRM_MARK_MODAL,
  CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL,
  SET_EMPLOYEE_CONFIRM_MARK_MODAL,
  EMPLOYEE_CONFIRM_START,
  OPEN_EMPLOYEE_CODE_MARK_MODAL,
  CLOSE_EMPLOYEE_CODE_MARK_MODAL,
  EMPLOYEE_CODE_START,
  EXECUTE_SIGN_MARKS_ERROR_CODE,
  MarksData,
  MarksState,
} from './types';
import { AnyAction } from 'redux';

const marksActions = {
  //obsługa akcji dotyczących pojedynczej oceny
  createPartialMark: (data: UniqueData, tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: CREATE_PARTIAL_MARK_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  updatePartialMark: (data: UniqueData, tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: UPDATE_PARTIAL_MARK_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  deletePartialMark: (data: UniqueData, tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: DELETE_PARTIAL_MARK_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  createFinalMark: (data: UniqueData, tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: CREATE_FINAL_MARK_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  updateFinalMark: (data: UniqueData, tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: UPDATE_FINAL_MARK_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  deleteFinalMark: (data: UniqueData, tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: DELETE_FINAL_MARK_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  //obsługa akcji grupowych
  createPartialMarks: (data: UniqueData[], tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: CREATE_PARTIAL_MARKS_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  updatePartialMarks: (data: UniqueData[], tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: UPDATE_PARTIAL_MARKS_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  deletePartialMarks: (data: UniqueData[], tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: DELETE_PARTIAL_MARKS_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  createFinalMarks: (data: UniqueData[], tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: CREATE_FINAL_MARKS_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  updateFinalMarks: (data: UniqueData[], tabId: number,
    studentId: number | string, refreshDataAction: any): MarksActionTypes => ({
    type: UPDATE_FINAL_MARKS_STARTED,
    payload: {
      data,
      tab: {
        tabId,
        studentId,
      },
      refreshDataAction,
    },
  }),
  openSignModal: (payload: MarksData): MarksActionTypes => ({
    type: OPEN_SIGN_MARK_MODAL,
    payload,
  }),
  closeSignModal: (): MarksActionTypes => ({
    type: CLOSE_SIGN_MARK_MODAL,
  }),
  signMarks: (): MarksActionTypes => ({
    type: SIGN_MARKS_START,
  }),
  openConfirmCodeModal: (mode: MarksState['codeConfirmModal']['mode']): MarksActionTypes => ({
    type: OPEN_CONFIRM_CODE_MARK_MODAL,
    payload: { mode },
  }),
  closeConfirmCodeModal: (): MarksActionTypes => ({
    type: CLOSE_CONFIRM_CODE_MARK_MODAL,
  }),
  confirmCodeMarks: (code: string, mode: MarksState['codeConfirmModal']['mode']): MarksActionTypes => ({
    type: CONFIRM_CODE_START,
    payload: { code, mode },
  }),
  openEmployeeConfirmModal: (): MarksActionTypes => ({
    type: OPEN_EMPLOYEE_CONFIRM_MARK_MODAL,
  }),
  closeEmployeeConfirmModal: (): MarksActionTypes => ({
    type: CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL,
  }),
  setEmployeeConfirmModal: (value: string): MarksActionTypes => ({
    type: SET_EMPLOYEE_CONFIRM_MARK_MODAL,
    payload: { value },
  }),
  confirmEmployeeConfirmModal: (): MarksActionTypes => ({
    type: EMPLOYEE_CONFIRM_START,
  }),
  openConfirmEmployeeCodeModal: (): MarksActionTypes => ({
    type: OPEN_EMPLOYEE_CODE_MARK_MODAL,
  }),
  closeConfirmEmployeeCodeModal: (): MarksActionTypes => ({
    type: CLOSE_EMPLOYEE_CODE_MARK_MODAL,
  }),
  confirmEmployeeCodeMarks: (code: string): MarksActionTypes => ({
    type: EMPLOYEE_CODE_START,
    payload: { code },
  }),
  executeMarksSigningErrorCode: (errorCode: number, failedAction: AnyAction, error: any): MarksActionTypes => ({
    type: EXECUTE_SIGN_MARKS_ERROR_CODE,
    payload: { code: errorCode, failedAction, error },
  }),
};

export default marksActions;